import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromUser from './user.reducer';


// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
} = fromUser.adapter.getSelectors();

export const selectUserState = createFeatureSelector<fromUser.State>('users');

export const selectUserIds = createSelector(
  selectUserState,
  (state): string[] => selectIds(state).map(String)
);
export const selectUserEntities = createSelector(
  selectUserState,
  selectEntities
);
export const selectAllUsers = createSelector(
  selectUserState,
  selectAll
);

export const selectUser = createSelector(
  selectUserState,
  state => state.user
);

